import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { addReqiredMessage } from '../../util/addRequiredMessage';
import { useForm } from '@/form/useForm.ts';
import { PhoneUtil } from '@/util/phoneUtils';

export const ContactPersonSummaryFormUS = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['alternateContact'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  // alternateContactFirstname: string;
  // alternateContactLastname: string;
  // alternateContactPhone: string;
  // alternateContactEmail: string;
  // alternateContactEmailConfirm: string;
  // alternateContactRelation: string;

  // alternateContactFirstname
  const alternateContactFirstnameField = addReqiredMessage({
    field: s.alternateContact.fields.find(({ name }) => name === 'alternateContactFirstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const alternateContactFirstnameLabel = translate(alternateContactFirstnameField?.label);

  // alternateContactLastname
  const alternateContactLastnameField = addReqiredMessage({
    field: s.alternateContact.fields.find(({ name }) => name === 'alternateContactLastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const alternateContactLastnameLabel = translate(alternateContactLastnameField?.label);

  // alternateContactPhone
  const alternateContactPhoneField = addReqiredMessage({
    field: s.alternateContact.fields.find(({ name }) => name === 'alternateContactPhone'),
    message: s.dataSummary.requiredMessage!,
  });
  const alternateContactPhoneLabel = translate(alternateContactPhoneField?.label);
  const phoneValue = getFieldValue('alternateContactPhone') ?? '';
  const decoratedPhoneNumber = PhoneUtil.formatPhoneNumber(phoneValue.toString(), 'national');

  //alternateContactEmail
  const alternateContactEmailField = addReqiredMessage({
    field: s.alternateContact.fields.find(({ name }) => name === 'alternateContactEmail'),
    message: s.dataSummary.requiredMessage!,
  });
  const alternateContactEmailLabel = translate(alternateContactEmailField?.label);

  //alternateContactEmailConfirm
  const alternateContactEmailConfirmField = addReqiredMessage({
    field: s.alternateContact.fields.find(({ name }) => name === 'alternateContactEmailConfirm'),
    message: s.dataSummary.requiredMessage!,
  });
  const alternateContactEmailConfirmLabel = translate(alternateContactEmailConfirmField?.label);

  // alternateContactRelation
  const alternateContactRelationField = addReqiredMessage({
    field: s.alternateContact.fields.find(({ name }) => name === 'alternateContactRelation'),
    message: s.dataSummary.requiredMessage!,
  });
  const alternateContactRelationLabel = translate(alternateContactRelationField?.label);
  const alternateContactRelationValue =
    translate(
      alternateContactRelationField?.options?.find(({ value }) => value === getFieldValue('alternateContactRelation'))
        ?.label
    ) || getFieldValue('alternateContactRelation');

  return (
    <div className="summary-card" data-cy={'summary-form-contact-person'}>
      <h2>{translate(s.dataSummary.titles?.firstContactPerson)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />
      <div className="data">
        <div className={'label'}>{alternateContactFirstnameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('alternateContactFirstname')}
          {editMode && <EditDataField field={alternateContactFirstnameField!} slideId={'alternateContact'} />}
        </div>

        <div className={'label'}>{alternateContactLastnameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('alternateContactLastname')}
          {editMode && <EditDataField field={alternateContactLastnameField!} slideId={'alternateContact'} />}
        </div>

        <div className={'label'}>{alternateContactEmailLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('alternateContactEmail')}
          {editMode && <EditDataField field={alternateContactEmailField!} slideId={'alternateContact'} />}
        </div>

        {editMode && (
          <>
            <div className={'label'}>{alternateContactEmailConfirmLabel}</div>
            <div className={'value'}>
              {!editMode && getFieldValue('alternateContactEmailConfirm')}
              {editMode && <EditDataField field={alternateContactEmailConfirmField!} slideId={'alternateContact'} />}
            </div>
          </>
        )}

        <div className={'label'}>{alternateContactPhoneLabel}</div>
        <div className={'value'}>
          {!editMode && decoratedPhoneNumber}
          {editMode && <EditDataField field={alternateContactPhoneField!} slideId={'alternateContact'} />}
        </div>

        <div className={'label'}>{alternateContactRelationLabel}</div>
        <div className={'value'}>
          {!editMode && alternateContactRelationValue}
          {editMode && <EditDataField field={alternateContactRelationField!} slideId={'alternateContact'} />}
        </div>
      </div>
    </div>
  );
};
